import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import TeamsList from '../Teams/TeamsList';

class SelectDealTeam extends Component {
  componentWillMount() {
    this.props.resetTeam();
  }

  handleNext() {
    this.props.hideAlert();

    if (this.props.team) {
      this.props.router.push('/create-deal/agreement-standalone');
    } else {
      this.props.alert('error', 'Please select a team');
    }
  }

  render() {
    return (
      <div className="select-team side">
        <Heading text="Which team did you create new deal with?" />
        <div className="content">
          <div className="main">
            <TeamsList type="create-deal" />
          </div>
        </div>
        <div className="step-nav">
          <div></div>
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  team: state.teams.selectedTeam,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  resetTeam: () => {
    dispatch(actions.selectTeam(null));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SelectDealTeam));



// WEBPACK FOOTER //
// src/components/Deals/SelectDealTeam.jsx